<!-- Link to external url -->
@if (file.resourceType === ResourceType.EXT_URL) {
  <a
    [href]="file.url"
    [ngClass]="buttonClass"
    [portalTippy]="'file.externalLink.info' | translate"
    target="_blank"
  >
    <i class="far fa-external-link"></i>
    <span class="ms-1">
      <ng-container *portalTransclusion="transclusions">
        {{ file.lang | uppercase }}
      </ng-container>
    </span>
  </a>
}

@if (file.resourceType === ResourceType.FILE || file.resourceType === ResourceType.EXT_DOWNLOAD) {
  <portal-file-download
    class="d-inline-flex"
    [btnClass]="buttonClass"
    [file]="file"
    [portalTippy]="'file.download.info' | translate"
    appendTo="body"
  >
    <i class="far fa-fw fa-arrow-to-bottom"></i>
    <ng-container *portalTransclusion="transclusions">
      {{ file.lang | uppercase }}
    </ng-container>
  </portal-file-download>
}
